import { contactsGateway } from "@/gateways/contactsGateway";
import type { MutationCallbacks } from "@/types";
import { useMutation } from "@tanstack/vue-query";

export function useConfirmContactEmail(
  token: string,
  callbacks: MutationCallbacks<void> = {},
) {
  const mutation = useMutation({
    mutationFn: () => contactsGateway.confirmEmail(token),
    onSuccess: () => {
      if (callbacks.onSuccess) callbacks.onSuccess();
    },
  });

  return {
    ...mutation,
    confirmContactEmailStatus: mutation.status,
    confirmContactEmail: mutation.mutate,
  };
}
